import { useState } from "react";

import { RoleGate } from "@/components/RoleGate";
import { useAtualizarUnidade, useCriarUnidade, useUnidades } from "@/hooks/useApi";

export function UnidadesPage() {
  return (
    <RoleGate allowed={["admin", "auditor"]}>
      <Inner />
    </RoleGate>
  );
}

function Inner() {
  const { data, isLoading } = useUnidades();
  const criar = useCriarUnidade();
  const [form, setForm] = useState({
    codigo: "",
    nome: "",
    logradouro: "",
    numero: "",
    bairro: "",
    cidade: "Santo André",
    uf: "SP",
    cep: "",
    cnpj: "",
  });

  async function handleSubmit() {
    await criar.mutateAsync(form);
    setForm({ ...form, codigo: "", nome: "", logradouro: "", numero: "", bairro: "", cep: "", cnpj: "" });
  }

  return (
    <div className="space-y-6">
      <div>
        <h2 className="font-display text-2xl font-semibold">Unidades</h2>
        <p className="text-sm text-ink-muted">Endereços físicos do Grupo Ana Rosa.</p>
      </div>

      <div className="card p-4">
        <h3 className="font-display text-base font-semibold">Nova unidade</h3>
        <div className="mt-3 grid grid-cols-2 gap-3 md:grid-cols-4">
          <input className="input" placeholder="código (ex: pediatria)" value={form.codigo}
            onChange={(e) => setForm({ ...form, codigo: e.target.value })} />
          <input className="input col-span-2" placeholder="nome" value={form.nome}
            onChange={(e) => setForm({ ...form, nome: e.target.value })} />
          <input className="input" placeholder="CEP" value={form.cep}
            onChange={(e) => setForm({ ...form, cep: e.target.value })} />
          <input className="input col-span-2" placeholder="logradouro" value={form.logradouro}
            onChange={(e) => setForm({ ...form, logradouro: e.target.value })} />
          <input className="input" placeholder="número" value={form.numero}
            onChange={(e) => setForm({ ...form, numero: e.target.value })} />
          <input className="input" placeholder="bairro" value={form.bairro}
            onChange={(e) => setForm({ ...form, bairro: e.target.value })} />
          <input className="input" placeholder="cidade" value={form.cidade}
            onChange={(e) => setForm({ ...form, cidade: e.target.value })} />
          <input className="input" placeholder="UF" maxLength={2} value={form.uf}
            onChange={(e) => setForm({ ...form, uf: e.target.value.toUpperCase() })} />
          <input className="input col-span-2" placeholder="CNPJ (cabeçalho do livro/BSPO)" value={form.cnpj}
            onChange={(e) => setForm({ ...form, cnpj: e.target.value })} />
        </div>
        <div className="mt-3">
          <button className="btn-primary" disabled={!form.codigo || !form.nome || criar.isPending}
            onClick={handleSubmit}>
            {criar.isPending ? "Salvando…" : "Adicionar"}
          </button>
        </div>
      </div>

      {isLoading ? <p className="text-ink-muted">Carregando…</p> : null}
      {data ? (
        <div className="card overflow-hidden">
          <table className="w-full text-sm">
            <thead className="bg-gray-50 text-left text-xs uppercase tracking-wider text-ink-muted">
              <tr>
                <th className="px-4 py-3">Código</th>
                <th className="px-4 py-3">Nome</th>
                <th className="px-4 py-3">Endereço</th>
                <th className="px-4 py-3">CNPJ</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100">
              {data.map((u) => (
                <tr key={u.id} className="hover:bg-gray-50">
                  <td className="px-4 py-2 font-mono text-xs">{u.codigo}</td>
                  <td className="px-4 py-2">{u.nome}</td>
                  <td className="px-4 py-2 text-ink-muted">
                    {u.logradouro} {u.numero}{u.bairro ? `, ${u.bairro}` : ""} — {u.cidade}/{u.uf}{" "}
                    {u.cep ? `· CEP ${u.cep}` : null}
                  </td>
                  <td className="px-4 py-2">
                    <CnpjInline id={u.id} atual={u.cnpj} />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : null}
    </div>
  );
}

/** CNPJ editável inline — as unidades existentes precisam receber o CNPJ
 * pro cabeçalho do Livro/BSPO sair por estabelecimento. */
function CnpjInline({ id, atual }: { id: string; atual: string | null }) {
  const atualizar = useAtualizarUnidade();
  const [valor, setValor] = useState(atual ?? "");
  const mudou = valor.trim() !== (atual ?? "");
  return (
    <div className="flex items-center gap-1">
      <input
        className="input py-1 text-xs w-40"
        placeholder="00.000.000/0000-00"
        value={valor}
        onChange={(e) => setValor(e.target.value)}
      />
      {mudou ? (
        <button
          className="btn-secondary px-2 py-1 text-xs"
          disabled={atualizar.isPending}
          onClick={() => atualizar.mutate({ id, patch: { cnpj: valor.trim() || null } })}
          title="Salvar CNPJ"
        >
          {atualizar.isPending ? "…" : "💾"}
        </button>
      ) : null}
    </div>
  );
}
